import React, { memo, ReactNode, useState } from "react";
import CommonHeader from "@payment-client/components/common-header";
import { CoreLayout, HeaderObserver } from "@swiggy-private/core-ui";
import { isJioHotstarFlow } from "@swiggy-private/checkout-core";

interface CommonUIWrapperProps {
    content: ReactNode;
    containerCSSClass?: string;
    header?: ReactNode;
    headerCSSClass?: string;
    onBack?: VoidFunction;
    headerExtraContent?: React.ReactElement;
    backButtonClass?: string;
    coreLayoutClass?: string;
}

const CommonUIWrapper = React.forwardRef<HTMLDivElement, CommonUIWrapperProps>(
    (props: CommonUIWrapperProps, ref): React.ReactElement => {
        const {
            content,
            header,
            backButtonClass,
            containerCSSClass,
            headerCSSClass,
            headerExtraContent,
            onBack,
            coreLayoutClass,
        } = props;

        const headerComponent = (
            <CoreLayout.Header>
                <CommonHeader
                    onBack={onBack}
                    containerClass={headerCSSClass}
                    isVisible={true}
                    backButtonClass={backButtonClass}
                >
                    {header}
                    {headerExtraContent}
                </CommonHeader>
            </CoreLayout.Header>
        );

        const [scrollContainer, setScrollContainer] = useState<HTMLElement | null>(null);

        return (
            <CoreLayout
                customClassName={coreLayoutClass}
                isJioHotstarFlow={isJioHotstarFlow()}
                data-jiohotstar={isJioHotstarFlow() ? "true" : undefined}
            >
                <>
                    {isJioHotstarFlow() ? (
                        <HeaderObserver scrollContainer={scrollContainer}>{headerComponent}</HeaderObserver>
                    ) : (
                        headerComponent
                    )}
                    <CoreLayout.Content
                        className={containerCSSClass}
                        ref={ref}
                        onScrollContainerReady={setScrollContainer}
                    >
                        {content}
                    </CoreLayout.Content>
                </>
            </CoreLayout>
        );
    },
);

if (__DEV__) CommonUIWrapper.displayName = "CommonUIWrapper";

export default memo(CommonUIWrapper);
